import React, {  Component } from 'react';
import CountUp from 'react-countup';
import { dbQuery  } from "../../../../api"
import { ArrowRightCircle, X, Check } from 'react-feather';

import '../../../../index.scss';

class RoundAvailabilityCube extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true,
            data: 0
        }
    }

    doQuery = () => {
        if (this.props.query) {       
            dbQuery(this.props.query).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});                    
    };

    doLocalQuery = (round, event, user) => {
        var data = (event.rooms.length || 0);
        
        return data;        
    }

    componentDidMount() {
        this.doQuery();
    }

    render(){
        if (this.state.loading) { return null; }
        const {round, event, user, bg} = this.props;
        var competitor = null;
        var judge = null;

        event.rooms.forEach(room => {
            if (!competitor) { competitor = room.competitors.find(x=>x.userId === user._id); }
            if (!judge) { judge = room.judges.find(x=>x.userId === user._id); }
        });

        var myStatus = <small>My Status: Inactive</small>
        if (competitor) myStatus = <small>My Status: {competitor.role}</small>
        if (judge) myStatus = <small>My Status: Judging</small>

        return (
            <div className="card o-hidden widget-cards">
                <div className={`${bg} card-body`}>
                    <div className="media static-top-widget row">
                        <div className="icons-widgets col-3">
                            
                            <div className="align-self-center text-center"><ArrowRightCircle className="font-primary" /></div>

                            <span >
                                <div className="align-self-center text-center" style={{marginTop: "4px", backgroundColor: "white"}}>
                                {competitor
                                ?   <span className="badge"><Check className="font-secondary" /></span>
                                :   <span className="badge"><X className="font-warning" /></span>
                                }                            
                                </div>
                            </span>
                        </div>

                        <div className="media-body col-9">
                            <span className="m-0" style={{cursor: 'pointer', textDecoration: "underline"}} onClick={() => this.props.onTitleClick ? this.props.onTitleClick() : null}>
                                <h3>{event.title}&nbsp;</h3>
                            </span>

                            <h3 className="mb-0">
                                <CountUp className="counter" end={this.doLocalQuery(round, event,user)} />
                                <small>   
                                    &nbsp;Rooms
                                </small>
                            </h3>


                            {round.status === 'posted' && <h3 className="mb-0"> {myStatus} </h3> }
                            {round.status === 'closed' && <h3 className="mb-0"> <small>Closed</small> </h3> }
                            {(round.status !== 'posted' && round.status !== 'closed') && <h3 className="mb-0"> {myStatus} </h3> }
                                                           
                        </div>    
                    </div>
                </div>
            </div>    
        )
    }
}

export default RoundAvailabilityCube;